import { render } from "./HomeMarketing.vue?vue&type=template&id=e1f8be2e"
import script from "./HomeMarketing.vue?vue&type=script&lang=js"
export * from "./HomeMarketing.vue?vue&type=script&lang=js"

import exportComponent from "/Users/jonathanthomas/Documents/Sites/vuejs/gr2022-phase-fin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__